import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_search';
export const route = 'alt_search/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_search" */
/* webpackPrefetch: true */
'../components/AltSearchPage')));